import type { ECountry } from '@/shared/enum/country.enum'
import { mpcProductionUrls, mpcStageUrls } from '@/shared/constants/mpc-url.constant'
import isStageEnvironment from '@/shared/utils/is-stage-environment'

const getMpcUrlByCountry = (country: ECountry): string | undefined => {
  const mpcUrls = isStageEnvironment() ? mpcStageUrls : mpcProductionUrls

  return mpcUrls.get(country)
}

export default getMpcUrlByCountry
